import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { StarRating } from './StarRating';
interface ReviewCardProps {
  name: string;
  initial: string;
  role?: string;
  rating: number;
  text: string;
  verified?: boolean;
  index?: number;
}
export function ReviewCard({
  name,
  initial,
  role,
  rating,
  text,
  verified = true,
  index = 0
}: ReviewCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    delay: index * 0.1
  }} className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-114">
      <div className="flex items-start gap-4 mb-4" data-id="element-115">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white font-semibold flex-shrink-0" data-id="element-116">
          {initial}
        </div>
        <div className="flex-1 min-w-0" data-id="element-117">
          <div className="flex items-center gap-2 mb-1" data-id="element-118">
            <p className="font-semibold text-gray-900" data-id="element-119">{name}</p>
            {verified && <CheckCircle size={14} className="text-green-600" data-id="element-120" />}
          </div>
          {role && <p className="text-xs text-gray-500" data-id="element-121">{role}</p>}
          <StarRating rating={rating} reviewCount={0} size="sm" className="mt-2" data-id="element-122" />
        </div>
      </div>
      <p className="text-sm text-gray-700 leading-relaxed" data-id="element-123">{text}</p>
    </motion.div>;
}